/* Sable Outdoor Living — minimal progressive enhancement.
   No libraries. Everything degrades to a working page without JS. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- Header scrolled state ---------------------------------------- */
  var header = document.querySelector('[data-sable-header]');
  if (header) {
    var setScrolled = function () {
      header.setAttribute('data-scrolled', window.scrollY > 12 ? 'true' : 'false');
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  /* ---- Desktop disclosure menus (click/keyboard, never hover) -------- */
  var disclosures = Array.prototype.slice.call(document.querySelectorAll('[data-sable-disclosure]'));
  function closeAll(except) {
    disclosures.forEach(function (btn) {
      if (btn === except) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }
  disclosures.forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      closeAll(btn);
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });
  });
  if (disclosures.length) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && !e.target.closest('[data-sable-megawrap]')) closeAll(null);
    });
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.closest && !e.target.closest('[data-sable-megawrap]')) closeAll(null);
    });
  }

  /* ---- Mobile drawer -------------------------------------------------- */
  var drawer = document.querySelector('[data-sable-drawer]');
  var burger = document.querySelector('[data-sable-burger]');
  if (drawer && burger) {
    var lastFocus = null;
    var focusables = function () {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
    };
    var openDrawer = function () {
      lastFocus = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      drawer.removeAttribute('inert');
      burger.setAttribute('aria-expanded', 'true');
      document.body.setAttribute('data-sable-drawer-open', 'true');
      var f = focusables();
      if (f.length) f[0].focus();
    };
    var closeDrawer = function () {
      drawer.setAttribute('data-open', 'false');
      burger.setAttribute('aria-expanded', 'false');
      document.body.removeAttribute('data-sable-drawer-open');
      window.setTimeout(function () {
        if (drawer.getAttribute('data-open') !== 'true') drawer.setAttribute('inert', '');
      }, 340);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    drawer.setAttribute('inert', '');
    burger.addEventListener('click', function () {
      if (drawer.getAttribute('data-open') === 'true') { closeDrawer(); } else { openDrawer(); }
    });
    var closeBtn = drawer.querySelector('[data-sable-drawer-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    drawer.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a[href]')) closeDrawer();
    });

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-sable-drawer-toggle]'), function (btn) {
      var sub = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sub) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        sub.hidden = open;
      });
    });

    var wide = window.matchMedia('(min-width: 1000px)');
    var onWide = function (e) { if (e.matches && drawer.getAttribute('data-open') === 'true') closeDrawer(); };
    if (wide.addEventListener) { wide.addEventListener('change', onWide); } else if (wide.addListener) { wide.addListener(onWide); }
  }

  /* ---- Sticky mobile CTA --------------------------------------------- */
  var cta = document.querySelector('[data-sable-stickycta]');
  if (cta) {
    document.body.setAttribute('data-sable-has-stickycta', 'true');
    var syncHeight = function () {
      document.documentElement.style.setProperty('--sbl-cta-h', cta.offsetHeight + 'px');
    };
    syncHeight();
    if (window.ResizeObserver) new ResizeObserver(syncHeight).observe(cta);

    var reveal = function () { cta.setAttribute('data-visible', window.scrollY > 320 ? 'true' : 'false'); };
    reveal();
    window.addEventListener('scroll', reveal, { passive: true });
    document.addEventListener('focusin', function (e) {
      if (e.target && e.target.matches && e.target.matches('input, textarea, select')) {
        cta.setAttribute('data-visible', 'false');
      }
    });
    document.addEventListener('focusout', function () { window.setTimeout(reveal, 80); });
  }

  /* ---- Scroll reveal --------------------------------------------------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.sable-reveal'));
  if (!reduce.matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-revealed', 'true');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.setAttribute('data-revealed', 'true'); });
  }

  /* ---- Only one FAQ open at a time (still works without JS) ----------- */
  var faqs = Array.prototype.slice.call(document.querySelectorAll('[data-sable-faq] details'));
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      faqs.forEach(function (other) { if (other !== d) other.open = false; });
    });
  });
})();
